import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./styles";

function SelectProfileCustomer({ setrolViewList, loading }) {
  const { t } = useTranslation();
  const [select, setSelet] = useState("all");

  useEffect(() => {
    setrolViewList(select);
  }, [select]);

  return (
    <s.Wrapper>
      <s.WrapperBottomComponents>
        <s.DataSelector loadingdata={loading}>
          <s.DateSelectorItem
            selected={select === "all"}
            left
            style={{ borderRadius: "2px 0  0 2px" }}
            onClick={() => setSelet("all")}
          >
            {t("components.CustomerList.TopMenu.SelectProfileCustomer.all")}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "person"}
            onClick={() => setSelet("person")}
          >
            {t(
              "components.CustomerList.TopMenu.SelectProfileCustomer.individual"
            )}
          </s.DateSelectorItem>
          <s.DateSelectorItem
            selected={select === "business"}
            style={{ borderRadius: "0 2px 2px 0" }}
            onClick={() => setSelet("business")}
          >
            {t("components.CustomerList.TopMenu.SelectProfileCustomer.company")}
          </s.DateSelectorItem>
        </s.DataSelector>
      </s.WrapperBottomComponents>
    </s.Wrapper>
  );
}

export default SelectProfileCustomer;
